import each from 'lodash/each'

import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class SingleProduct extends Page {
    constructor() {
        super({
            id: 'single_product',
            element: '[data-app-page]',
            elements: {
                versions: '#info div.versions',
            },
        })
    }

    async create() {
        super.create()

        if (this.elements.versions) {
            let versions = {
                default: this.elements.versions.querySelector('span.label .current').innerText,
                label: this.elements.versions.querySelector('span.label .current'),
                entries: this.elements.versions.querySelectorAll('ul.versions li a')
            }

            each(versions.entries, (entry, index) => {
                let label = entry.querySelector('figcaption').innerText

                entry.addEventListener('mouseover', (event) => { versions.label.innerText = label })
                entry.addEventListener('mouseleave', (event) => { versions.label.innerText = versions.default })
            })
        }
    }

    addEventListeners() {
        window.addEventListener('resize', () => {
            // app.content.style.setProperty('--header-height', `${this.elements.header.clientHeight}px`)
        })
    }

    destroy() {
        super.destroy()
    }
}